import { extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { useState, useRef, useEffect } from 'react';
import { Box } from '@mui/material';
import moment from 'moment';
import PropTypes from 'prop-types';
import ReactDatePicker from 'react-datepicker';
import { StyledReactDatePickerWrapper, StyledReactDatePickerCalendarContainer, StyledReactDatePickerCalendarContainerWithoutCalendar } from './DatePicker.styles.js';
import DatePickerCusstomHeader from './DatePickerCustomHeader.js';
import DatePickerCustomInput from './DatePickerCustomInput.js';
const DatePicker = /*#__PURE__*/React__default.forwardRef((_ref, ref) => {
  let {
    quickSelectOptions,
    dateRange,
    setDateRange,
    datePickerProps,
    inputContainerStyle,
    allText
  } = _ref;
  const [hasCustomDate, setHasCustomDate] = useState(false);
  const [defaultStartDateTimestamp, defaultEndDateTimestamp] = dateRange;
  const [startDateTimestamp, setStartDateTimestamp] = useState(defaultStartDateTimestamp);
  const [endDateTimestamp, setEndDateTimestamp] = useState(defaultEndDateTimestamp);
  const dateRef = ref || useRef(null);
  useEffect(() => {
    if (dateRange && dateRange[0] && dateRange[1]) {
      setStartDateTimestamp(dateRange[0]);
      setEndDateTimestamp(dateRange[1]);
    } else {
      setStartDateTimestamp(null);
      setEndDateTimestamp(null);
    }
  }, [dateRange]);
  const handleTimestampToDate = (dateTimestamp, timestampType) => {
    if (!dateTimestamp) return null;
    const offsetInHours = moment().utcOffset() / 60;
    if (timestampType === 'end' && offsetInHours > 0) return moment(dateTimestamp).subtract(1, 'days').toDate();
    if (timestampType === 'start' && offsetInHours < 0) return moment(dateTimestamp).add(1, 'days').toDate();
    return moment(dateTimestamp).startOf('day').toDate();
  };
  const handleQuickSelect = (days, label) => {
    switch (label) {
      case 'All':
        {
          var _dateRef$current;
          setDateRange([null, null]);
          dateRef === null || dateRef === void 0 || (_dateRef$current = dateRef.current) === null || _dateRef$current === void 0 || _dateRef$current.setOpen(false); // Close the datepicker after selection
          break;
        }
      case 'Custom':
        {
          break;
        }
      default:
        {
          var _dateRef$current2;
          const now = moment().utc().endOf('day').valueOf();
          const start = moment().utc().startOf('day').subtract(days - 1, 'days').valueOf();
          setDateRange([start, now]);
          dateRef === null || dateRef === void 0 || (_dateRef$current2 = dateRef.current) === null || _dateRef$current2 === void 0 || _dateRef$current2.setOpen(false); // Close the datepicker after selection
          break;
        }
    }
  };
  const renderButtons = () => /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      display: 'flex',
      flexDirection: 'column',
      gap: '16px'
    }
  }, quickSelectOptions.map(_ref2 => {
    let {
      days,
      label
    } = _ref2;
    return /*#__PURE__*/React__default.createElement(Box, {
      key: days,
      onClick: () => handleQuickSelect(days, label),
      sx: {
        cursor: 'pointer',
        height: '21px'
      }
    }, label);
  }));
  const handleCalendarClose = () => {
    if (startDateTimestamp && !endDateTimestamp) {
      setStartDateTimestamp(dateRange[0]);
      setEndDateTimestamp(dateRange[1]);
    }
  };
  useEffect(() => {
    // if label === 'Custom' in quickSelectOptions, set hasCustomDate to true
    const hasCustom = quickSelectOptions.some(_ref3 => {
      let {
        days
      } = _ref3;
      return days === 'custom';
    });
    setHasCustomDate(hasCustom);
  }, [quickSelectOptions]);
  return /*#__PURE__*/React__default.createElement(StyledReactDatePickerWrapper, null, /*#__PURE__*/React__default.createElement(ReactDatePicker, _extends({
    ref: dateRef,
    selectsRange: true,
    startDate: handleTimestampToDate(startDateTimestamp, 'start'),
    endDate: handleTimestampToDate(endDateTimestamp, 'end') // moment -> Date
    ,

    onChange: update => {
      const [startTimestamp, endTimestamp] = update;
      const convertedStartDate = moment(startTimestamp).utcOffset(0, true).startOf('day');
      if (!endTimestamp) {
        setStartDateTimestamp(convertedStartDate.valueOf());
        setEndDateTimestamp(null);
      } else {
        const convertedEndDate = moment(endTimestamp).utcOffset(0, true).endOf('day');
        setDateRange([convertedStartDate.valueOf(), convertedEndDate.valueOf()]);
      }
    },
    dateFormat: "d MMM yyyy",
    maxDate: moment().toDate() // Prevent selecting future dates
    ,

    customInput: /*#__PURE__*/React__default.createElement(DatePickerCustomInput, {
      inputContainerStyle: inputContainerStyle,
      allText: allText
    }),
    calendarContainer: hasCustomDate ? StyledReactDatePickerCalendarContainer : StyledReactDatePickerCalendarContainerWithoutCalendar,
    popperPlacement: "bottom-start",
    renderCustomHeader: DatePickerCusstomHeader,
    onCalendarClose: handleCalendarClose,
    showPopperArrow: false
  }, datePickerProps), renderButtons()));
});
DatePicker.propTypes = {
  quickSelectOptions: PropTypes.arrayOf(PropTypes.shape({
    days: PropTypes.number,
    label: PropTypes.string.isRequired
  })),
  allText: PropTypes.string
};
DatePicker.defaultProps = {
  quickSelectOptions: [{
    days: 1,
    label: '1 Day'
  }, {
    days: 7,
    label: '7 Days'
  }, {
    days: 30,
    label: '30 Days'
  }, {
    days: 'all',
    label: 'All'
  }, {
    days: 'custom',
    label: 'Custom'
  }],
  allText: 'All'
};
var DatePicker$1 = DatePicker;
export { DatePicker$1 as default };